export const ADVERTISING_CONSENT_COOKIE = '_cmp_advertising';
export const ANALYTICS_CONSENT_COOKIE = '_cmp_analytics';
export const MARKETING_CONSENT_COOKIE = '_cmp_marketing';
export const PERSONALISATION_CONSENT_COOKIE = '_cmp_personalisation';
